<template>
  <div>
    <!-- Timezone -->
    <div class="mb-3">
      <div class="alert alert-primary mb-0">
        Times being showed in the timezone: <strong>{{ timezone }}</strong>
      </div>
    </div>
    <!-- / Timezone -->

    <div class="types-wrapper">
      <div class="left">
        <label for="">
          Types To Show:
        </label>
      </div>
      <div class="right">
        <el-checkbox-group v-model="types">
          <el-checkbox label="Notes"></el-checkbox>
          <el-checkbox label="Forwarding"></el-checkbox>
          <el-checkbox label="Replies"></el-checkbox>
          <el-checkbox label="SMS"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- {{ eventsFiltered }} -->

    <!-- Time Created Chart -->
    <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="eventsFilteredGroupedByType" :scale="graphScale">
      <v-tooltip />
      <v-axis />
      <v-stack-bar position="hourFormatted*count" color="type" />
      <!-- <v-stack-bar position="hourFormatted*Forwarding" /> -->
      <v-legend />
    </v-chart>
    <!-- / Time Created Chart -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      types: [
        'Notes',
        'Forwarding',
        'Replies',
        'SMS'
      ],

      graphHeight: 350,
      graphScale: [{
        dataKey: 'count'
      }]
    }
  },

  methods: {
    formatHour(hour) {
      if (hour > 12) {
        return (hour - 12) + ' PM';
      } else {
        return hour + ' AM';
      }
    },

    determineNumberOfEventsWhereHourIs(hour, type) {
      return _.filter(this.eventsFiltered, event => {
        return moment.utc(event.created_at).tz(window.itgTimezone).hour() === hour
          && event.type === type;
      }).length;
    },
  },

  computed: {
    ...mapGetters('reportEditor', {
      results: 'results',
      agents: 'agents'
    }),

    eventsCombined() {
      // Get all the event_dates from all the events
      let events = [];
      this.results.forEach(result => {
        result.event_dates.forEach(event => {
          events.push(event);
        });
      });
      return events;
    },

    eventsFiltered() {
      // Filter the events by the types selected
      return this.eventsCombined.filter(event => {

        if (event.type == 'ticket_note') {
          return this.types.includes('Notes');
        }

        if (event.type == 'ticket_forwarding_log') {
          return this.types.includes('Forwarding');
        }

        if (event.type == 'ticket_reply') {
          return this.types.includes('Replies');
        }

        if (event.type == 'ticket_sms_log') {
          return this.types.includes('SMS');
        }

        return true;
      });
    },

    timezone() {
      return window.itgTimezone;
    },

    hourBins() {
      let bins = [];
      for (let i = 0; i < 24; i++) {
        bins.push(i);
      }
      return bins;
    },

    eventsFilteredGroupedByType() {
      let counts = [];
      _.each(this.hourBins, hour => {
        counts.push({
          hour: hour,
          hourFormatted: this.formatHour(hour),
          label: this.formatHour(hour) + ' - ' + (this.formatHour(hour + 1)),
          type: 'Notes',
          count: this.determineNumberOfEventsWhereHourIs(hour, 'ticket_note')
        });
        counts.push({
          hour: hour,
          hourFormatted: this.formatHour(hour),
          label: this.formatHour(hour) + ' - ' + (this.formatHour(hour + 1)),
          type: 'Forwarding',
          count: this.determineNumberOfEventsWhereHourIs(hour, 'ticket_forwarding_log')
        });
        counts.push({
          hour: hour,
          hourFormatted: this.formatHour(hour),
          label: this.formatHour(hour) + ' - ' + (this.formatHour(hour + 1)),
          type: 'Replies',
          count: this.determineNumberOfEventsWhereHourIs(hour, 'ticket_reply')
        });
        counts.push({
          hour: hour,
          hourFormatted: this.formatHour(hour),
          label: this.formatHour(hour) + ' - ' + (this.formatHour(hour + 1)),
          type: 'SMS',
          count: this.determineNumberOfEventsWhereHourIs(hour, 'ticket_sms_log')
        });
      });
      return counts;
    }
  }
}
</script>

<style scoped lang="scss">
.types-wrapper {
  display: flex;
  padding: 15px 20px;
  border-radius: 5px;
  background: #F5F7FA;
  margin-bottom: 20px;

  .left {
    label {
      margin-bottom: 0;
    }

    margin-right: 30px;
  }

  .el-checkbox {
    margin-bottom: 0;
  }
}
</style>